module.exports = __webpack_public_path__ + "img/U1F923.aa821076.png";